<template>
  <div class="ws-info-date">{{_value}}</div>
</template>

<script>
export default {
  computed: {
    _value() {
      if (!this.value) {
        return null;
      } else {
        return this.$moment(this.value).format("YYYY-MM-DD");
      }
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style>
</style>